import { ResponsiveText } from '@farmersdog/corgi';

import { SpanRenderer } from './SpanRenderer';
import styles from './TextTypeRenderer.css';
import { TextNodeType } from './types';

import type { TextNode } from './types';

export interface TextTypeRendererProp {
  nodes: TextNode[];
}

export function TextTypeRenderer({ nodes }: TextTypeRendererProp) {
  return (
    <>
      {nodes.map((node, key) => {
        const { type, spans, text } = node;

        switch (type) {
          case TextNodeType.paragraph: {
            return (
              <ResponsiveText
                key={key}
                as="p"
                variant="article-1"
                color="charcoal-3"
                className={styles.paragraph}
              >
                <SpanRenderer spans={spans} text={text} />
              </ResponsiveText>
            );
          }

          case TextNodeType.heading1: {
            return (
              <ResponsiveText
                key={key}
                as="h1"
                variant="heading-1"
                color="kale-3"
                className={styles.h1}
              >
                <SpanRenderer spans={spans} text={text} />
              </ResponsiveText>
            );
          }

          case TextNodeType.heading2: {
            return (
              <ResponsiveText
                key={key}
                as="h2"
                variant="heading-2"
                color="kale-3"
                className={styles.h2}
              >
                <SpanRenderer spans={spans} text={text} />
              </ResponsiveText>
            );
          }

          case TextNodeType.heading3: {
            return (
              <ResponsiveText
                key={key}
                as="h3"
                variant="heading-3"
                color="kale-3"
                className={styles.h3}
              >
                <SpanRenderer spans={spans} text={text} />
              </ResponsiveText>
            );
          }

          case TextNodeType.heading4: {
            return (
              <ResponsiveText
                key={key}
                as="h4"
                variant="heading-4"
                color="kale-3"
                className={styles.h4}
              >
                <SpanRenderer spans={spans} text={text} />
              </ResponsiveText>
            );
          }

          case TextNodeType.heading5: {
            return (
              <ResponsiveText
                key={key}
                as="h5"
                variant="heading-5"
                color="kale-3"
                className={styles.h5}
              >
                <SpanRenderer spans={spans} text={text} />
              </ResponsiveText>
            );
          }

          case TextNodeType.heading6: {
            return (
              <ResponsiveText
                key={key}
                as="h6"
                variant="heading-5"
                color="kale-3"
                className={styles.h6}
              >
                <SpanRenderer spans={spans} text={text} />
              </ResponsiveText>
            );
          }
        }
      })}
    </>
  );
}
